module.exports = __webpack_public_path__ + "img/programming.014f361f.svg";